((w) => {
    "use strict";

    const assetId = '~/theme/v1/Views/Document/ViewDocumentTemplatedNewsletters.min.js';

    if (!((w).umwAssets?.[assetId])) {
        console.error(`No context found for ${assetId}`);
        return;
    }

    for (const ctx of (w).umwAssets[assetId]) {
        const newsletterControl = document.querySelector('.subscribe-newsletter') as HTMLElement | null;
        const newsletterDoc = document.querySelector('#' + ctx.mainPanelId) as HTMLElement | null;
        const newsletterDocDescription = newsletterDoc?.querySelector('.description') as HTMLElement | null;
        if (newsletterControl && newsletterDoc && newsletterDocDescription) {
            newsletterDoc.classList.add('has-newsletter-control');
            newsletterDocDescription.appendChild(newsletterControl);
            const newsletterHeader = newsletterControl.querySelector('header') as HTMLElement | null;
            if (newsletterHeader) {
                newsletterHeader.setAttribute('hidden', 'hidden');
            }
        }
    }
})(window as any);